export default __webpack_public_path__ + "static/media/nav_detail_image_5.138faf9a.png";